import { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import contactImg from "../assets/img/contact-img.jpg";
import "animate.css";

export const Contact = () => {
  const formInitialDetails = {
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
  };
  const [formDetails, setFormDetails] = useState(formInitialDetails);

  const onFormUpdate = (category, value) => {
    setFormDetails({
      ...formDetails,
      [category]: value,
    });
  };

  const openEmail = (e) => {
    e.preventDefault();

    const myEmail = "smes93434@gmail.com";
    const name = `${formDetails.firstName} ${formDetails.lastName}`;
    const phone =
      formDetails.phone !== "" ? `\nPhone: ${formDetails.phone}` : "";
    const email =
      formDetails.email !== "" ? `\nEmail: ${formDetails.email}` : "";

    // Manually add the line breaks using double encoding
    const bodyContent = `${formDetails.message}\n\n\n${name}${phone}${email}`;

    // Construct the Gmail link with body content encoded
    const gmailLink = `https://mail.google.com/mail/?view=cm&fs=1&to=${myEmail}&su=It's happy to connect with you&body=${encodeURIComponent(
      bodyContent
    )}`;

    setFormDetails(formInitialDetails);
    window.open(gmailLink, "_blank");
  };

  return (
    <section className="contact" id="connect">
      <Container>
        <Row className="align-items-center">
          <Col size={12} md={6}>
            <img src={contactImg} alt="Contact Us" />
          </Col>
          <Col size={12} md={6}>
            <div>
              <h2>Get In Touch</h2>
              <h3>
                Feel free to email me at{" "}
                <span className="email-text">smes93434@gmail.com</span> or
                complete the form below
              </h3>
              <form>
                <Row>
                  <Col size={12} sm={6} className="px-1">
                    <input
                      type="text"
                      value={formDetails.firstName}
                      placeholder="First Name"
                      onChange={(e) =>
                        onFormUpdate("firstName", e.target.value)
                      }
                    />
                  </Col>
                  <Col size={12} sm={6} className="px-1">
                    <input
                      type="text"
                      value={formDetails.lastName}
                      placeholder="Last Name"
                      onChange={(e) => onFormUpdate("lastName", e.target.value)}
                    />
                  </Col>
                  <Col size={12} sm={6} className="px-1">
                    <input
                      type="email"
                      value={formDetails.email}
                      placeholder="Email Address"
                      onChange={(e) => onFormUpdate("email", e.target.value)}
                    />
                  </Col>
                  <Col size={12} sm={6} className="px-1">
                    <input
                      type="tel"
                      value={formDetails.phone}
                      placeholder="Phone No."
                      onChange={(e) => onFormUpdate("phone", e.target.value)}
                    />
                  </Col>
                  <Col size={12} className="px-1">
                    <textarea
                      rows="6"
                      value={formDetails.message}
                      placeholder="Message"
                      onChange={(e) => onFormUpdate("message", e.target.value)}
                    ></textarea>
                    <button type="submit" onClick={openEmail}>
                      <span>Sent</span>
                    </button>
                  </Col>
                </Row>
              </form>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
